export enum InstrumentSelectionOptions {
  All = 'All'
}
